import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import ButtonInput          from '../Fields/ButtonInput';
import FaCross              from 'react-icons/lib/fa/close';

class SaveForLaterModal extends Component {
    componentWillMount() {
        this.setState({
            isActive: this.props.isActive
        });
    }

    toggleIsActive() {
        this.setState({
            isActive: !this.state.isActive
        });
    }

    render() {
        return(
            <div className={this.state.isActive ? 'modal-container modal-active' : 'modal-container'}>
                <div className="modal medium-width has-footer">
                    <div className="modal-header">
                        Information saved
                        <div className="close-cross" onClick={this.toggleIsActive.bind(this)}>
                            <FaCross className="pointer" />
                        </div>
                    </div>

                    <div className="modal-body">
                        <div className="content">
                            <p>Information saved</p>
                            <p>The information that you&rsquo;ve entered so far for your application has been saved.</p>
                            <p>To return and complete your application please use the link in the original email request.</p>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <ButtonInput
                            id="closeSaveForLaterModal"
                            buttonText="OK"
                            classNames="btn-default"
                            onClickEvent={this.toggleIsActive.bind(this)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

SaveForLaterModal.propTypes = {
    isActive: PropTypes.bool.isRequired,
};

SaveForLaterModal.defaultProps = {
    isActive: false,
};

export default SaveForLaterModal;


// WEBPACK FOOTER //
// ./src/components/Fragments/SaveForLaterModal.js